export const UPLOAD_DOCUMENT = 'documents/UPLOAD'
export const EDIT_DOCUMENT_TAG = 'documents/EDIT_TAG'
export const REMOVE_DOCUMENT = 'documents/REMOVE'
export const UPDATE_DOCUMENT_TYPE = 'documents/UPDATE_DOCUMENT_TYPE'
export const GET_DOCUMENT_BY_CONTRACT = 'documents/GET_BY_CONTRACT'
